import { combineReducers } from 'redux';
import { addressCapture } from '../slices/addressCapture';
import { addressDetails } from '../slices/addressDetails';
import { citizenshipDetails } from '../slices/citizenshipDetails';
import { contactDetails } from '../slices/contactDetails';
import { employmentDetails } from '../slices/employmentDetails';
import { personalDetails } from '../slices/personalDetails';
import { marketingPreferences } from '../slices/marketingPreferences';
import { financialDetails } from '../slices/financialDetails';
import { reviewDetails } from '../slices/reviewDetails';
import { configDetails } from '../slices/configDetails';
import { api } from '../slices/api';

const rootReducer = combineReducers({
  addressCapture: addressCapture.reducer,
  addressDetails: addressDetails.reducer,
  citizenshipDetails: citizenshipDetails.reducer,
  config: configDetails.reducer,
  contactDetails: contactDetails.reducer,
  employmentDetails: employmentDetails.reducer,
  personalDetails: personalDetails.reducer,
  marketingPreferences: marketingPreferences.reducer,
  financialDetails: financialDetails.reducer,
  reviewDetails: reviewDetails.reducer,
  api: api.reducer
});

export { rootReducer };
